export default {
  SET_donor(state, payload) {
    state.donor = payload;
  }
};
